const LangSidebar = {
	"sidebar.navigation._account": ["ACCOUNT SUMMARY", "គណនី​សង្ខេប"],
	"sidebar.navigation._rewards": ["MY REWARDS", "រង្វាន់​​​ខ្ញុំ"],
	"sidebar.navigation._profile": ["MY PROFILE", "ប្រវត្តិរូប​​ខ្ញុំ"],
	"sidebar.navigation._cards": ["MY CARDS", "កាត​​ខ្ញុំ"],
	"sidebar.navigation._transactions": [
		"TRANSACTION HISTORY",
		"ប្រវត្តិ​​​ប្រតិបត្តិការ",
	],
	"sidebar.navigation._contactUs": ["CONTACT US", "ទំនាក់ទំនង​មក​យើង​ខ្ញុំ"],
	"sidebar.navigation._logout": ["SIGN OUT", "ចេញ​ពី​គណនី"],
	"sidebar.navigation._unregister": ["UNREGISTER", "លុប​គណនី"],
	"sidebar.navigation._downloadMobile": [
		"DOWNLOAD MOBILE APP",
		"បញ្ចូល​​កម្មវិធី​ទូរស័ព្ទ",
	],
	"sidebar.navigation._havingDifficulties": [
		"HAVING DIFFICULTIES? ",
		"ត្រូវ​ការ​ជំនួយ?",
	],
	"sidebar.navigation._contact": ["CONTACT", "សូមទាក់​ទង​"],
	"sidebar.navigation._contactCsv": [
		"OUR CUSTOMER SERIVCE NOW",
		"ផ្នែក​បម្រើ​សេវា​អតិថិជន​របស់​យើង​ខ្ញុំ​ឥឡូវ​នេះ",
	],
}

export default LangSidebar



// WEBPACK FOOTER //
// ./src/resources/modules/LangSidebar.js